/* eslint-disable */

<template>
  <div class="vx-col">
    <vx-card class="mb-base">
      <div class="w-full flex justify-center relative click-item-container">
        <div class="image-container flex items-center" style="position: relative">
          <img
            src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02652061151464840495342/sim-lines3.png"
            draggable="false"
            style="width: 100%; height: 100%"
          />

          <!-- SUBNET ONE -->
          <div class="flex flex-col absolute" style="left: 28.6rem; top: 11.5rem">
            <v-select
              :options="answerChoices"
              v-model="questions[0].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[0].score === false ? '1px solid #c93738' : questions[0].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="left: 28.6rem; top: 19.1rem">
            <v-select
              :options="answerChoices"
              v-model="questions[1].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[1].score === false ? '1px solid #c93738' : questions[1].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <!-- TOP THREE WIDE -->
          <div class="flex flex-col absolute" style="left: 28.6rem; top: 27rem">
            <v-select
              :options="answerChoices"
              v-model="questions[2].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[2].score === false ? '1px solid #c93738' : questions[2].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="left: 11.25rem; top: 27rem">
            <v-select
              :options="answerChoices"
              v-model="questions[3].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[3].score === false ? '1px solid #c93738' : questions[3].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="right: 11.25rem; top: 27rem">
            <v-select
              :options="answerChoices"
              v-model="questions[4].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[4].score === false ? '1px solid #c93738' : questions[4].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <!-- TOP MIDDLE ABOVE NIC -->
          <div class="flex flex-col absolute" style="left: 0.5rem; bottom: 22rem">
            <v-select
              :options="answerChoices"
              v-model="questions[5].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[5].score === false ? '1px solid #c93738' : questions[5].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="right: 0.45rem; bottom: 22.1rem">
            <v-select
              :options="answerChoices"
              v-model="questions[6].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[6].score === false ? '1px solid #c93738' : questions[6].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <!-- MIDDLE FOUR WIDE -->
          <div class="flex flex-col absolute" style="left: 0.5rem; bottom: 11.7rem">
            <v-select
              :options="answerChoices"
              v-model="questions[7].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[7].score === false ? '1px solid #c93738' : questions[7].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="left: 19.3rem; bottom: 11.7rem">
            <v-select
              :options="answerChoices"
              v-model="questions[8].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[8].score === false ? '1px solid #c93738' : questions[8].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="right: 19.3rem; bottom: 11.7rem">
            <v-select
              :options="answerChoices"
              v-model="questions[9].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[9].score === false ? '1px solid #c93738' : questions[9].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="right: 0.45rem; bottom: 11.7rem">
            <v-select
              :options="answerChoices"
              v-model="questions[10].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[10].score === false ? '1px solid #c93738' : questions[10].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <!-- BOTTOM THREE WIDE -->
          <div class="flex flex-col absolute" style="left: 15.8rem; bottom: 4.5rem">
            <v-select
              :options="answerChoices"
              v-model="questions[11].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[11].score === false ? '1px solid #c93738' : questions[11].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="right: 19.6rem; bottom: 4.5rem">
            <v-select
              :options="answerChoices"
              v-model="questions[12].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[12].score === false ? '1px solid #c93738' : questions[12].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>

          <div class="flex flex-col absolute" style="right: 2.8rem; bottom: 4.5rem">
            <v-select
              :options="answerChoices"
              v-model="questions[13].value"
              class="w-64 popup-dropdown rounded"
              :style="{
                border: questions[13].score === false ? '1px solid #c93738' : questions[13].score === true && '1px solid #28c76f',
              }"
              placeholder="Select answer"
            />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';
import LottieAnimation from '../../../../../../../../components/lottie/LottieAnimation';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      componentSelectingIndex: -1,

      answerChoices: [
        'UPS A',
        'UPS B',
        'Load Balancers',
        'Cloud Service Provider',
        'SONET ring',
        'Layer 3 device',
        'Power supply A',
        'Power supply B',
        'Proxy',
        'Active-passive firewalls',
        'Active-active firewalls',
        'Active-standy routers',
        'Active-active routers',
        'Layer 4 firewall',
        'Generator',
        'SAN',
        'ISP',
      ],

      questions: [
        {
          value: '',
          answer: 'Active-active routers',
          score: null,
        },
        {
          value: '',
          answer: 'Active-active firewalls',
          score: null,
        },
        {
          value: '',
          answer: 'Load Balancers',
          score: null,
        },
        {
          value: '',
          answer: 'Active-active firewalls',
          score: null,
        },
        {
          value: '',
          answer: 'Active-active routers',
          score: null,
        },
        {
          value: '',
          answer: 'Load Balancers',
          score: null,
        },
        {
          value: '',
          answer: 'Load Balancers',
          score: null,
        },
        {
          value: '',
          answer: 'Power supply A',
          score: null,
        },
        {
          value: '',
          answer: 'Power supply B',
          score: null,
        },
        {
          value: '',
          answer: 'Power supply A',
          score: null,
        },
        {
          value: '',
          answer: 'Power supply B',
          score: null,
        },
        {
          value: '',
          answer: 'UPS A',
          score: null,
        },
        {
          value: '',
          answer: 'UPS B',
          score: null,
        },
        {
          value: '',
          answer: 'SONET ring',
          score: null,
        },
      ],
    };
  },
  methods: {
    markSimulation() {
      let total_score = 0;

      this.questions.forEach((field, index) => {
        if (field.value === field.answer) {
          this.questions[index].score = true;
          total_score++;
        } else {
          this.questions[index].score = false;
        }
      });

      if (total_score === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', total_score);
      }

      this.$emit('simulation_getting_there', total_score);
    },
  },
  components: {
    Prism,
    vSelect,
    MovablePopup,
    LottieAnimation,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
